const BrandColors = {
  SEMANTIC_COLOR_PRIMARY: "purple",
  SEMANTIC_COLOR_SECONDARY: "teal",
  SEMANTIC_COLOR_TERTIARY: "orange",
  HEX_COLOR_PRIMARY: "#922BD2",
  HEX_COLOR_SUCCESS: "#00ca72"
};

export default BrandColors;